<template>
  <div class="instock-batch-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="btn-group ub">
          <div class="btn-add ub-f1">
            <input type="file" ref="file" id="file" multiple="multiple" @change="handleFile" />
            <div style="display: inline-block">
              <i class="icon icon-add"></i>
              <span>{{ $t('fms_invoice_import_dialog.qxzmbgswj') }}</span>
            </div>
          </div>
          <div class="btn-tpl" @click="onDownloadTpl">
            <div style="display: inline-block">
              <i class="icon icon-daochu"></i>
              <span>&ensp;{{ $t('fms_invoice_import_dialog.dkpzdmb') }}</span>
            </div>
          </div>
        </div>
        <div class="search" style="height: 40px; overflow: hidden">
          <el-form :inline="true">
            <el-form-item>
              <el-button @click="showOk = true" :type="showOk ? 'primary' : ''" :plain="!showOk">{{ $t('fms_invoice_import_dialog.tong_guo_yan_zheng') }}（{{ okNum }}）</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="showOk = false" :type="!showOk ? 'primary' : ''" :plain="showOk">{{ $t('fms_invoice_import_dialog.yi_chang_shu_ju') }}（{{ failNum }}）</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 验证通过 -->
        <div v-show="showOk">
          <custom-table :data="okList" tableCode="invoice_import" :filterArr="['errorMsg']" :slots="['invoiceType']">
            <template v-slot:invoiceType="scope">
              {{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) || '' }}
            </template>
          </custom-table>
        </div>
        <!-- 验证失败 -->
        <div v-show="!showOk">
          <custom-table :data="failList" tableCode="invoice_import" :slots="['invoiceType']">
            <template v-slot:invoiceType="scope">
              {{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) || '' }}
            </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button v-if="showOk" type="primary" :disabled="!!failNum || !okNum" @click="saveInStock">{{ $t('fms_invoice_import_dialog.que_ren_dao_ru') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';

export default {
  mixins: [dialogMixins, invoiceTypeMixins],
  data() {
    return {
      failList: [],
      failNum: 0,
      okList: [],
      okNum: 0,
      showOk: true,
    };
  },
  mounted() {
  },
  methods: {
    // 模板下载
    onDownloadTpl: function () {
      this.$exportFlie(apis.invoiceWaitTplDownload);
    },
    // 文件上传
    handleFile: function (e) {
      this.$postFile(apis.invoiceWaitExcelImport, e)
        .then((res) => {
          this.$message({ message: this.$t('Common.com_handle_success'), type: 'success' });
          this.$refs.file.value = '';
          this.failList = res.data.failList || [];
          this.failNum = res.data.failNum || 0;
          this.okList = res.data.successList || [];
          this.okNum = res.data.okNum || 0;
        })
        .catch(() => {
          this.$refs.file.value = '';
        });
    },
    // 确认导入
    saveInStock: function () {
      this.$postJSON(`${apis.invoiceWaitExcelSave}`, this.okList).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.instock-batch-dialog {
  .btn-group {
    margin-bottom: 20px;
    .btn-add {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(245, 245, 245, 1);
      border: 1px dashed rgba(228, 228, 228, 1);
      color: #333333;
      font-size: 12px;
      position: relative;
      cursor: pointer;
      input {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .btn-tpl {
      width: 162px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgba(228, 228, 228, 1);
      margin-left: 10px;
      color: #333333;
      font-size: 12px;
      cursor: pointer;
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
  .result {
    padding: 6px 10px 0;
    color: #262626;
    font-size: 12px;
    height: 40px;
    .ok {
      color: blue;
    }
    .fail {
      color: red;
    }
  }
}
</style>
